export class HttpheadersModel {
  public Nonce: string;
  public Timestamp: string;
  public signature: string;
  public X_USER_TOKEN: string;
  public X_TOKEN: string;
  public X_CLIENT_ID?: string;
  public X_AUTH_TOKEN?: string;
  public accessToken?: string;
  public accessKey: string;
  public X_SECRET: string;
  public Rexpay_checkout: string;
  public httpBrowserLanguage: string;
  public httpBrowserJavaEnabled: string;
  public httpBrowserJavaScriptEnabled: string;
  public httpBrowserColorDepth: string;
  public httpBrowserScreenHeight: string;
  public httpBrowserScreenWidth: string;
  public httpBrowserTimeDifference: string;
  public userAgentBrowserValue: string;
  public httpBrowserTZ: string;
  public httpBrowserAcceptHeader: string;

  public deviceInformation: DeviceInformation;
}

export interface DeviceInformation {
  httpBrowserLanguage: string;
  httpBrowserJavaEnabled: string;
  httpBrowserJavaScriptEnabled: string;
  httpBrowserColorDepth: string;
  httpBrowserScreenHeight: string;
  httpBrowserScreenWidth: string;
  httpBrowserTimeDifference: string;
  userAgentBrowserValue: string;
  httpBrowserTZ: string;
  httpBrowserAcceptHeader: string;
}
